export default "__VITE_ASSET__BUMRpPkJ__"